import vue from 'vue'
import { clientId, clientSecret, getCommonData } from 'common/js/reqdata'
import storage from 'good-storage'
import axios from 'axios'
import {Hub} from 'common/js/hub'
import { urls } from 'api/apiUrlConfig'

function getUser () {
  const user = vue.prototype.Hub.user
  return new Promise((resolve, reject) => {
    if (user) {
      user.logourl = user.logourl
      resolve(user)
    } else {
      resolve(user)
    }
  })
}

function setStorage (key, value) {
  if (key == 'user') {
    Hub.user = value
  }
  storage.set(key, value)
  if (key == 'token') {
    axios.defaults.data = getCommonData()
  }
}

function getStorage (key) {
  return storage.get(key)
}

function setUser (params) {
  const url = urls.setUser
  return vue.axios.post(url, {
    reqdata: params
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

/* 被邀请人  */
function getinvite (redirectUrl) {
  const url = urls.getinvite
  return vue.axios.post(url, {
    reqdata: redirectUrl
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
/* 邀请人的个人信息 */
function invitationUserInfo (key) {
  const url = urls.invitationUserInfo
  return vue.axios.post(url, {
    reqdata: key
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
// 获取邀请的二维码链接
function Qrcode (redirectUrl) {
  const url = urls.qucodeurl
  return vue.axios.post(url, {
  }).then(res => {
    return Promise.resolve(res.data)
  })
}

function weiChatLogin (code, stat) {
  const url = urls.weiChatLogi
  return vue.axios.post(url, {
    reqdata: {
      code: code,
      stat: stat,
      clientId: clientId,
      clientSecret: clientSecret
    }
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
/* 微信手机号 */
function weiChatPhone (openId, phone, smsCode) {
  const url = urls.weiChatPhone
  return vue.axios.post(url, {
    reqdata: {
      clientId: clientId,
      clientSecret: clientSecret,
      openId: openId,
      phone: phone,
      smsCode: smsCode
    }
  }).then(res => {
    return Promise.resolve(res.data)
  })
}
function getRedirectUrl (redirectUrl) {
  const url = urls.getRedirectUrl + `?redirectUrl=${redirectUrl}`
  return vue.axios.post(url).then(res => {
    return Promise.resolve(res.data)
  })
}

export {
  getUser,
  setUser,
  Qrcode,
  getinvite,
  weiChatLogin,
  weiChatPhone,
  getRedirectUrl,
  setStorage,
  getStorage,
  invitationUserInfo
}



// WEBPACK FOOTER //
// ./src/api/user.js